@if (badge) {
  <div class="product-banner" [ngStyle]="getStyles()">
    <span>{{ badge.title }}</span>
  </div>
}
